import React from 'react';
import { LogIn, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AuthNudgeProps {
  title: string;
  description: string;
  onOpenAuth: () => void;
  type?: 'login' | 'supporter';
  onOpenUpgrade?: () => void;
}

const AuthNudge: React.FC<AuthNudgeProps> = ({
  title,
  description,
  onOpenAuth,
  type = 'login',
  onOpenUpgrade
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center animate-in fade-in zoom-in duration-500">
      <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-2xl ${
        type === 'supporter' ? 'bg-amber-500/20 text-amber-500' : 'bg-emerald-500/20 text-emerald-500'
      }`}>
        {type === 'supporter' ? <Sparkles size={32} /> : <LogIn size={32} />}
      </div>
      
      <h3 className="text-xl font-black mb-3 bg-gradient-to-br from-white to-stone-400 bg-clip-text text-transparent">
        {title}
      </h3>
      
      <p className="text-[var(--text-secondary)] text-sm leading-relaxed mb-8 max-w-[280px]">
        {description}
      </p>
      
      <div className="flex flex-col gap-3 w-full max-w-[240px]">
        <button
          onClick={onOpenAuth}
          className="w-full py-3.5 px-6 rounded-2xl bg-emerald-500 text-stone-950 font-black shadow-[0_0_20px_rgba(16,185,129,0.3)] hover:scale-[1.02] active:scale-95 transition-all flex items-center justify-center gap-2"
        >
          <LogIn size={18} />
          {t('account.login', 'Logg inn')}
        </button>
        
        {type === 'supporter' && onOpenUpgrade && (
          <button
            onClick={onOpenUpgrade}
            className="w-full py-3.5 px-6 rounded-2xl bg-amber-500 text-stone-950 font-black shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:scale-[1.02] active:scale-95 transition-all flex items-center justify-center gap-2"
          >
            <Sparkles size={18} />
            {t('account.upgrade', 'Oppgrader')}
          </button>
        )}
      </div>
      
      <div className="mt-12 p-4 rounded-2xl glass-strong border border-white/5 max-w-[320px]">
        <p className="text-2xs uppercase font-black tracking-widest text-emerald-500/60 mb-2">{t("auto.common.authnudge.visste_du", "Visste du?")}</p>
        <p className="text-tiny text-[var(--text-muted)] italic">
          {type === 'supporter' 
            ? "Supportere får tilgang til unike kartlag, detaljert historikk og AI-analyser av tusenvis av steder."
            : "Ved å logge inn kan du lagre dine egne funn, ruter og planlegge din neste ekspedisjon på alle enheter."}
        </p>
      </div>
    </div>
  );
};

export default AuthNudge;
